import { useEffect, useRef } from 'react';

export const usePreventScroll = (condition: boolean) => {
  const positionY = useRef(0);

  useEffect(() => {
    positionY.current = window?.pageYOffset ?? 0;
  }, []);

  useEffect(() => {
    const scrollPosition = window.pageYOffset;
    if (condition) {
      document.getElementsByTagName('html')[0].style.height = '100vh';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
      positionY.current = scrollPosition;
    } else {
      document.getElementsByTagName('html')[0].style.removeProperty('height');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      window.scrollTo(0, positionY.current);
    }
  }, [condition]);
};
